var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('card',[_c('div',{staticClass:"text-center mx-auto",staticStyle:{"max-width":"825px"}},[_c('VueFaqAccordion',{attrs:{"items":_vm.myItems}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }